export enum CombinedMenuItemTypeEnum {
  Biology = 1,
  Chemistry = 2,
  Physics = 3,
}
